<template>
  <div :class="$style.root">
    <div :class="$style.ruleToggle" @click="showRuelPop = true">详细规则</div>
    <img :class="$style.banner" :src="banner" class="u-block u-width100pct" />
    <div :class="$style.pintuanList">
      <PinTuanItem
        :class="$style.pintuanItem"
        v-for="item in items"
        :item="item"
        :key="item.id"
        @click="selectGood"
      />
    </div>
    <PinPanZhuangQu v-if="isWeChat && items.length" class="u-marginTop10"/>
    <DialogRule :visible.sync="showRuelPop">
      {{ resource.rule }}
    </DialogRule>
  </div>
</template>

<script>
import { makeUrl } from "utils/url";
import { isWeChat } from "helper/env";
import PinTuanItem from "../../../190506-@shared/components/PinTuanItem";
import service from "../../service";
import DialogRule from "../../../190506-@shared/components/DialogRule";
import PinPanZhuangQu from "../../../190506-@shared/components/PinPanZhuangQu";

export default {
  name: "ActList",
  props: {
    banner: {},
    items: {
      default() {
        return [];
      },
    },
  },
  inject: ["resource"],
  components: {
    PinTuanItem,
    DialogRule,
    PinPanZhuangQu,
  },
  data() {
    return {
      isWeChat,
      showRuelPop: false,
    };
  },
  methods: {
    selectGood(item) {
      const url = window.location.href.split("#")[0];
      const withoutQuery = url.replace(/\?.*$/, "");
      if (item.isPay) {
        const targetUrl = withoutQuery.replace("pin-tuan", "pin-tuan-act");
        const jumpUrl = makeUrl(targetUrl, { actcode: item.actCode, webid: item.webId });
        service.gotoUrl(jumpUrl);
      } else {
        const targetUrl = withoutQuery.replace("pin-tuan", "pin-tuan-good");
        const jumpUrl = makeUrl(targetUrl, {
          actcode: item.actCode,
          goodid: item.goodId,
          ...(item.webId && { webid: item.webId }),
        });
        service.gotoUrl(jumpUrl);
      }
    },
  },
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.root {
  // position: relative;
}

.banner {
  min-height: rem(183);
}

.ruleToggle {
  position: absolute;
  top: rem(10);
  right: 0;
  padding: 0 6px 0 7px;
  line-height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  background: rgba(241, 169, 165, 1);
  border-radius: 15px 0 0 15px;
}

.pintuanList {
  margin-top: 15px;
  background: #fff;
}
</style>
